import {ITableColumn} from '../../types';
import {ReactNode} from 'react';

export type ApplicationDimension = { name: string, value: string }

export enum ApplicationCategory {
    ADMIN = 'ADMIN',
    BUSINESS = 'BUSINESS',
    CONSUMER = 'CONSUMER',
}

// FNP-1675: CREATING, FAILED, DELETING and DECOMMISSIONED were written only by
// the retired provisioning flow. They stay here because live rows still carry
// them and the record must still load; the form and the filter offer only
// ACTIVE and INACTIVE. FNP-1680 removes them once no row holds one.
export enum ApplicationStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    CREATING = 'CREATING',
    FAILED = 'FAILED',
    DELETING = 'DELETING',
    DECOMMISSIONED = 'DECOMMISSIONED',
}

export type ApplicationTag = {
    key: string,
    value: string,
}


export type Application = {
    id: string,
    name?: string,
    description?: string,
    url?: string,
    logoUrl?: string
    applicationCategory?: ApplicationCategory,
    applicationStatus?: ApplicationStatus,
    createdByUsername?: string,
    createdBy?: { givenName: string, familyName: string },
    updatedByUsername?: string
    updatedBy?: { givenName: string, familyName: string },
    created?: string,
    updated?: string,

    displayName?: string,
    tags?: ApplicationTag[],
}


export type ApplicationRecordFormProps = {
    record: Application,
    handleSubmit: (values: Application) => void
    handleCancel: () => void
}

export interface IApplicationTableColumn extends ITableColumn {
    render?: (item: Application) => ReactNode;
}
